// extracted by css-extract-rspack-plugin
export default {"textButton":"textButton-hKb2Ys","plainHover":"plainHover-SQXcdX","primaryEmphasis":"primaryEmphasis-QCUeVM"};